import { Injectable } from "@angular/core";
import { LobbyDataService } from "./data/LobbyDataService";
import { SettingsService } from "@gatho/services/api/settings.service";
import { map, switchMap, mergeMap, Subject, shareReplay } from "rxjs";
import { Site, SiteType } from "@shared/models";

export type DefaultNavLevel = { type: 'siteType' | 'site'; value: SiteType | Site };

@Injectable({ providedIn: 'root' })
export class NavigationService
{
  public routeTypeMap = {
    area: '/area/',
    site: '/areas/',
    siteType: '/sites/'
  };

  private _defaultUuid$ = this._settings.settings$.pipe(
    map(settings => settings.default_navigation_level),
  );

  public defaultSiteType$ = this._defaultUuid$.pipe(
    switchMap(uuid => this._lobbyData.allSiteTypes$.pipe(
      mergeMap(items => items.filter(x => x.uuid === uuid)),
    ))
  );

  public defaultSite$ = this._defaultUuid$.pipe(
    switchMap(uuid => this._lobbyData.allSites$.pipe(
      mergeMap(items => items.filter(x => x.uuid === uuid)),
    ))
  );

  private _defaultItem = new Subject<DefaultNavLevel | undefined>();
  public defaultItem$ = this._defaultItem.pipe(shareReplay(1));

  private _defaultLevel?: DefaultNavLevel;
  public get defaultLevel()
  {
    return this._defaultLevel;
  }

  constructor(
    private _settings: SettingsService,
    private _lobbyData: LobbyDataService
  ) {
    this.defaultSiteType$.subscribe(value => {
      this._defaultItem.next({ type: 'siteType', value });
    });
    this.defaultSite$.subscribe(value => {
      this._defaultItem.next({ type: 'site', value });
    });
    // If setting is voided clear default item
    this._defaultUuid$.subscribe(setting => {
      if (!setting) this._defaultItem.next(undefined);
    });
    this.defaultItem$.subscribe(item => {
      if (item) this._defaultLevel = item;
    });
  }
}
